import FilterForm from '../../../components/forms/FilterForm';
import { Col, Form, Input, Row, Select, Space, Table } from 'antd';
import { CrudFilters, HttpError } from '@refinedev/core';
import {
  EditButton,
  List,
  TagField,
  TextField,
  useTable
} from '@refinedev/antd';
import { TOfferCampaign } from 'interfaces/offers';
import { tagColorByStatus } from '../../../utils/statusColorMapping';

interface IFilter {
  name: string;
  status: string;
}

export const OfferCampaignList = () => {
  const { tableProps, searchFormProps } = useTable<
    TOfferCampaign,
    HttpError,
    IFilter
  >({
    onSearch: params => {
      const filters: CrudFilters = [];
      const { name, status } = params;

      filters.push(
        {
          field: 'filter[name]',
          operator: 'eq',
          value: name
        },
        {
          field: 'filter[status]',
          operator: 'eq',
          value: status
        }
      );

      return filters;
    }
  });

  return (
    <Row gutter={[16, 16]}>
      <Col span={24}>
        <List>
          <FilterForm searchFormProps={searchFormProps}>
            <Form.Item label="Nome" name="name">
              <Input placeholder="Nome da campanha..." />
            </Form.Item>
            <Form.Item label="Status" name="status">
              <Select placeholder="Selecione..." style={{ minWidth: 200 }}>
                <Select.Option key="disabled">Desabilitado</Select.Option>
                <Select.Option key="expired">Expirado</Select.Option>
                <Select.Option key="active">Ativo</Select.Option>
              </Select>
            </Form.Item>
          </FilterForm>
          <Table {...tableProps} rowKey="id">
            <Table.Column
              dataIndex="name"
              key="name"
              title="Nome"
              render={value => <TextField value={value} />}
            />
            <Table.Column
              dataIndex="status"
              key="status"
              title="Status"
              render={value => (
                <TagField
                  color={tagColorByStatus(value)}
                  value={
                    value === 'disabled'
                      ? 'Desabilitado'
                      : value === 'expired'
                      ? 'Expirado'
                      : value === 'active'
                      ? 'Ativo'
                      : '-'
                  }
                />
              )}
            />
            <Table.Column<TOfferCampaign>
              title="Ações"
              dataIndex="actions"
              align="center"
              render={(_, record) => {
                return (
                  <Space>
                    <EditButton
                      hideText
                      size="small"
                      recordItemId={record.id}
                    />
                  </Space>
                );
              }}
            />
          </Table>
        </List>
      </Col>
    </Row>
  );
};
